import { motion } from 'framer-motion';
import HeroSection from './components/HeroSection';
import PainPointsSection from './components/PainPointsSection';
import SolutionSection from './components/SolutionSection';
import CTASection from './components/CTASection';

function App() {
  return (
    <main className="min-h-screen bg-warm-200 font-body overflow-x-hidden">
      <HeroSection />
      <PainPointsSection />
      <SolutionSection />
      <CTASection />
    </main>
  );
}

export default App;
